import { Button } from "antd"

function LinkedIn(){

    const CLIENT_ID = "86rnfjwusv15ud";
    const REDIRECT_URI = "http://localhost:3000/linkedin-callback";
    const AUTH_URL = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&scope=openid%20profile%20email%20w_member_social%20w_member_social_feed`;

    
    const handleLogin = () => {
        window.location.href = AUTH_URL;
  };

    return(
        <div>
            <Button onClick={handleLogin }>Continue with linked in</Button>
        </div>
    )

}

export default LinkedIn